// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfileComplianceFact-modulefactLabel__T75cl";
var _2 = "ApplicantProfileComplianceFact-modulefactValue__RIzr1";
export { _1 as "factLabel", _2 as "factValue" }
